<template>
  <InputField
    class="input-field-copy"
    disabled
    v-bind="$attrs"
    fullWidth
    @iconClick="copy"
  >
    <div slot="iconEnd">
      <Icon :name="icon" class="text-dull-dark" />
    </div>
  </InputField>
</template>

<script>
import InputField from '../InputField';
import Label from '../Label';
import Icon from '../Icon';

export default {
  // inheritAttrs: true,

  name: 'InputFieldCopy',

  components: {
    InputField,
    Icon,
  },

  props: {
    icon: {
      type: String,
      default: 'clipboard',
    },
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.$attrs.value);
        this.dispatchToast({
          type: 'success',
          title: `Copied to clipboard`,
        });
      } catch (e) {
        this.dispatchToast({
          type: 'error',
          title: `Error copying value`,
        });
      }
    },
  },
};
</script>

<style scoped>
.input-field-copy {
  cursor: pointer !important;
}
</style>
